/**
 * @typedef { import('../../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../../time.js').YearMonth } YearMonth
 * @typedef { import('./report.js').Report } Report
 * @typedef { import('./report.js').Cohort } Cohort
 */

/**
 * @param {Report} report
 * @returns {string}
 */
 export function convertReportToTriangleString(report) {
  let str = "cohort,revenue\n";

  const period = report.getPeriod();

  const beginMonth = period.getBegin();
  const endMonth   = period.getEnd();

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
    const cohort = report.getCohort(month);
    const cohortStr = convertCohortToString(cohort, month, endMonth);
    str += cohortStr + "\n";
  }

  return str;
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} beginMonth
 * @param {YearMonth} endMonth
 * @returns {string}
 */
function convertCohortToString(cohort, beginMonth, endMonth) {
  const parts = [cohort.getName()];

  const metricStr = convertMetricsToString(cohort, beginMonth, endMonth);
  parts.push(metricStr);
  
  return parts.join(',');
}

/**
 * @param {Cohort} cohort
 * @param {YearMonth} beginMonth
 * @param {YearMonth} endMonth
 * @returns {string}
 */
 function convertMetricsToString(cohort, beginMonth, endMonth) {
  /** @type {string[]} */
  const valueStrs = [];

  for(let month = beginMonth; month.isBefore(endMonth); month = month.getNext()) {
      const value = cohort.getMetric(month);
      valueStrs.push(value.toString());
  }

  return valueStrs.join(',');
}
